function pad(n) {
  return String(n).padStart(2, '0');
}

// Formats a Date as a floating local time for VALUE=DATE-TIME (no Z suffix),
// since matched_date has no timezone and we're picking an arbitrary lunch hour.
function toLocalICSTime(date) {
  return `${date.getFullYear()}${pad(date.getMonth() + 1)}${pad(date.getDate())}T${pad(date.getHours())}${pad(date.getMinutes())}00`;
}

function escapeICSText(text) {
  return String(text).replace(/\\/g, '\\\\').replace(/,/g, '\\,').replace(/;/g, '\\;').replace(/\n/g, '\\n');
}

export function downloadMatchICS(match) {
  const [year, month, day] = match.matched_date.split('-').map(Number);
  const start = new Date(year, month - 1, day, 12, 0, 0);
  const end = new Date(year, month - 1, day, 13, 0, 0);

  const names = (match.participants?.map(p => p.name) || [match.matched_user_name]).filter(Boolean);
  const title = `match-a Lunch with ${names.join(', ')}`;
  const description = `Lunch matched via match-a with ${names.join(', ')}.`;

  const lines = [
    'BEGIN:VCALENDAR',
    'VERSION:2.0',
    'PRODID:-//match-a//Lunch//EN',
    'BEGIN:VEVENT',
    `UID:match-a-${match.id}@match-a`,
    `DTSTAMP:${toLocalICSTime(new Date())}`,
    `DTSTART:${toLocalICSTime(start)}`,
    `DTEND:${toLocalICSTime(end)}`,
    `SUMMARY:${escapeICSText(title)}`,
    `DESCRIPTION:${escapeICSText(description)}`,
    'END:VEVENT',
    'END:VCALENDAR'
  ];
  const icsContent = lines.join('\r\n');

  const blob = new Blob([icsContent], { type: 'text/calendar;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `match-a-lunch-${match.matched_date}.ics`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
